import styled from 'styled-components';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import { paddingBuilder } from 'styles/themeUtils';

const VideoDevice = styled.video`
  order: 2;
  align-self: center;
  max-width: 22.5rem;
  width: 100%;
  max-height: 38.125rem;

  ${paddingBuilder.all(0, 1.75)}

  ${tablet768`
    order: 0;
    margin-bottom: 0;

    ${paddingBuilder.all(0, 2)}
  `}
`;

VideoDevice.displayName = 'VideoDevice';

export default VideoDevice;
